import React from "react";
import { toast } from "sonner";
import { Linkedin, Twitter, Mail, Link2 } from "lucide-react";

export default function ShareProfileBar({ name }) {
  const baseUrl = window.location.origin + window.location.pathname;
  const text = `Check out ${name}'s AI Career Portfolio on Data Cloud Quest!`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(baseUrl);
      toast.success("Portfolio link copied!");
    } catch {
      toast.error("Could not copy link. Please copy it manually from the address bar.");
    }
  };

  return (
    <div className="flex items-center justify-center gap-2 flex-wrap" data-testid="portfolio-share-bar">
      <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(baseUrl + "?src=linkedin")}`} target="_blank" rel="noreferrer" data-testid="share-linkedin-btn" className="flex items-center gap-1.5 text-xs font-semibold bg-[#0A66C2]/15 hover:bg-[#0A66C2]/25 text-[#5DA1F1] px-3.5 py-2 rounded-lg transition-colors">
        <Linkedin className="w-3.5 h-3.5" /> LinkedIn
      </a>
      <a href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(baseUrl + "?src=twitter")}`} target="_blank" rel="noreferrer" data-testid="share-twitter-btn" className="flex items-center gap-1.5 text-xs font-semibold bg-white/5 hover:bg-white/10 text-slate-300 px-3.5 py-2 rounded-lg transition-colors">
        <Twitter className="w-3.5 h-3.5" /> Twitter / X
      </a>
      <a href={`mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(baseUrl + "?src=email")}`} data-testid="share-email-btn" className="flex items-center gap-1.5 text-xs font-semibold bg-white/5 hover:bg-white/10 text-slate-300 px-3.5 py-2 rounded-lg transition-colors">
        <Mail className="w-3.5 h-3.5" /> Email
      </a>
      <button onClick={copyLink} data-testid="share-copy-link-btn" className="flex items-center gap-1.5 text-xs font-semibold bg-white/5 hover:bg-white/10 text-slate-300 px-3.5 py-2 rounded-lg transition-colors">
        <Link2 className="w-3.5 h-3.5" /> Copy Link
      </button>
    </div>
  );
}
